import React from 'react';
import { FormattedMessage } from 'react-intl';
import H1 from 'shared/app/components/h1';

import messages from '../messages';
import JoinRewardsCta from './join-rewards-cta';
import MarriottHeader from './marriott-header';

export const PartnershipHeader = ({ partnership }) => {
  return partnership.id === 'marriottLink' ||
    partnership.id === 'marriottUnlink' ? (
    <MarriottHeader isMarriottUnlinking={partnership.id === 'marriottUnlink'} />
  ) : (
    <React.Fragment>
      <H1 className="text-bold text-center mb2" size="lg">
        <FormattedMessage {...messages.signInHeaderPartnership} />
      </H1>
      <div className="pt2">
        <p className="text-center">
          <FormattedMessage {...messages.signInDontHaveAnAccount} />
        </p>
        <JoinRewardsCta />
      </div>
    </React.Fragment>
  );
};

export default PartnershipHeader;
